module.exports = __webpack_public_path__ + "static/img/swiperitem03.3999ed35.jpg";